import {
	defaultTqcInspectResultDtlDto,
	TqcInspectResultDtlDto,
} from "src/dtos/tqcInspectResult/tqcInspectResultDto";
import {
	defaultWmsTransportDetailDto,
	WmsTransportDetailDto,
} from "src/dtos/wmsTransport/wmsTransportDto";

export interface TQC3010_R01HeaderDto extends WmsTransportDetailDto {
	inoutClass: string;
	inoutClassNm: string;
	customCd: string;
	customNm: string;
	itemGroup: string;
	lotNo: string;
	inspectNo: string;
	inspectType: string;
	inspectDt: string;
	inspectorEmp: string;
	inspectorEmpNm: string;
	approvorEmpno: string;
	approvorEmpNm: string;
}

export const defaultTQC3010_R01HeaderDto: TQC3010_R01HeaderDto = {
	...defaultWmsTransportDetailDto,
	inoutClass: "",
	inoutClassNm: "",
	customCd: "",
	customNm: "",
	itemGroup: "",
	lotNo: "",
	inspectNo: "",
	inspectType: "",
	inspectDt: "",
	inspectorEmp: "",
	inspectorEmpNm: "",
	approvorEmpno: "",
	approvorEmpNm: "",
};

export interface TQC3010_R01DetailDto extends TqcInspectResultDtlDto {
	inspItemGroup: string;
	inspType: string;
	inspItemNm: string;
	specText: string;
	valueType: string;
	valueTypeNm: string;
	inspUnit: string;
	valueIndex: number;
	isModified: boolean;
	inserted: boolean;
}

export const defaultTQC3010_R01DetailDto: TQC3010_R01DetailDto = {
	...defaultTqcInspectResultDtlDto,
	inspItemGroup: "",
	inspType: "",
	inspItemNm: "",
	specText: "",
	valueType: "",
	valueTypeNm: "",
	inspUnit: "",
	valueIndex: 0,
	isModified: false,
	inserted: false,
};

export interface TQC3010_R01Dto {
	header: TQC3010_R01HeaderDto;
	detailList: TQC3010_R01DetailDto[];
}

export const TQC3010_R01_COMP_CD = "1000";
export const TQC3010_R01_VALUE_FIELDS = [
	"inspectValue1_1",
	"inspectValue1_2",
	"inspectValue1_3",
	"inspectValue1_4",
	"inspectValue1_5",
] as const;
